import React, { useMemo, useState } from 'react';
import { Star, ChevronUp, ChevronDown } from 'lucide-react';
import { marketData } from '../../utils/portfolioData';
import { MiniSparkline } from './MiniSparkline';
interface MarketRow {
  name: string;
  symbol: string;
  logo: string;
  leverage: string;
  price: number;
  change24h: number;
  low24h: number;
  high24h: number;
  volume24h: string;
  marketCap: string;
  isFavorite: boolean;
  priceHistory: number[];
}
const additionalMarkets: MarketRow[] = [{
  name: 'Dogecoin',
  symbol: 'DOGE/USD',
  logo: 'https://cryptologos.cc/logos/dogecoin-doge-logo.svg',
  leverage: '5x',
  price: 0.1623,
  change24h: 4.52,
  low24h: 0.1545,
  high24h: 0.1678,
  volume24h: '22.1M',
  marketCap: '$23.4B',
  isFavorite: false,
  priceHistory: [0.155, 0.156, 0.157, 0.158, 0.159, 0.16, 0.161, 0.162, 0.163, 0.164, 0.163, 0.162, 0.161, 0.16, 0.159, 0.16, 0.161, 0.162, 0.163, 0.164, 0.163, 0.162, 0.162, 0.1623]
}, {
  name: 'Shiba Inu',
  symbol: 'SHIB/USD',
  logo: 'https://cryptologos.cc/logos/shiba-inu-shib-logo.svg',
  leverage: '3x',
  price: 0.00002341,
  change24h: -3.15,
  low24h: 0.00002278,
  high24h: 0.00002425,
  volume24h: '14.8M',
  marketCap: '$13.8B',
  isFavorite: false,
  priceHistory: [0.0000242, 0.0000241, 0.000024, 0.0000239, 0.0000238, 0.0000237, 0.0000236, 0.0000235, 0.0000234, 0.0000233, 0.0000234, 0.0000235, 0.0000236, 0.0000235, 0.0000234, 0.0000233, 0.0000234, 0.0000235, 0.0000234, 0.0000234, 0.0000234, 0.0000234, 0.0000234, 0.00002341]
}, {
  name: 'Pepe',
  symbol: 'PEPE/USD',
  logo: 'https://cryptologos.cc/logos/pepe-pepe-logo.svg',
  leverage: '3x',
  price: 0.00001287,
  change24h: 8.34,
  low24h: 0.00001178,
  high24h: 0.00001312,
  volume24h: '31.2M',
  marketCap: '$5.4B',
  isFavorite: false,
  priceHistory: [0.0000118, 0.0000119, 0.000012, 0.0000121, 0.0000122, 0.0000123, 0.0000124, 0.0000125, 0.0000126, 0.0000127, 0.0000128, 0.0000129, 0.000013, 0.0000131, 0.000013, 0.0000129, 0.0000128, 0.0000129, 0.000013, 0.0000129, 0.0000129, 0.0000129, 0.0000129, 0.00001287]
}, {
  name: 'Arbitrum',
  symbol: 'ARB/USD',
  logo: 'https://cryptologos.cc/logos/arbitrum-arb-logo.svg',
  leverage: '5x',
  price: 1.124,
  change24h: -0.45,
  low24h: 1.098,
  high24h: 1.156,
  volume24h: '8.7M',
  marketCap: '$4.3B',
  isFavorite: false,
  priceHistory: [1.13, 1.132, 1.135, 1.138, 1.14, 1.138, 1.135, 1.132, 1.13, 1.128, 1.126, 1.124, 1.122, 1.12, 1.122, 1.124, 1.126, 1.125, 1.124, 1.123, 1.124, 1.124, 1.124, 1.124]
}, {
  name: 'Optimism',
  symbol: 'OP/USD',
  logo: 'https://cryptologos.cc/logos/optimism-ethereum-op-logo.svg',
  leverage: '5x',
  price: 2.347,
  change24h: 1.89,
  low24h: 2.278,
  high24h: 2.398,
  volume24h: '6.3M',
  marketCap: '$3.1B',
  isFavorite: false,
  priceHistory: [2.28, 2.29, 2.3, 2.31, 2.32, 2.33, 2.34, 2.35, 2.36, 2.37, 2.38, 2.39, 2.38, 2.37, 2.36, 2.35, 2.34, 2.35, 2.35, 2.35, 2.35, 2.35, 2.347, 2.347]
}, {
  name: 'Sui',
  symbol: 'SUI/USD',
  logo: 'https://cryptologos.cc/logos/sui-sui-logo.svg',
  leverage: '3x',
  price: 1.876,
  change24h: 6.23,
  low24h: 1.752,
  high24h: 1.912,
  volume24h: '18.9M',
  marketCap: '$5.8B',
  isFavorite: false,
  priceHistory: [1.76, 1.77, 1.78, 1.79, 1.8, 1.81, 1.82, 1.83, 1.84, 1.85, 1.86, 1.87, 1.88, 1.89, 1.9, 1.89, 1.88, 1.87, 1.88, 1.88, 1.88, 1.88, 1.876, 1.876]
}, {
  name: 'Aptos',
  symbol: 'APT/USD',
  logo: 'https://cryptologos.cc/logos/aptos-apt-logo.svg',
  leverage: '3x',
  price: 8.934,
  change24h: -2.67,
  low24h: 8.712,
  high24h: 9.234,
  volume24h: '7.1M',
  marketCap: '$3.9B',
  isFavorite: false,
  priceHistory: [9.2, 9.18, 9.15, 9.12, 9.1, 9.08, 9.05, 9.02, 9.0, 8.98, 8.96, 8.94, 8.92, 8.9, 8.92, 8.94, 8.93, 8.93, 8.93, 8.93, 8.934, 8.934, 8.934, 8.934]
}, {
  name: 'NEAR Protocol',
  symbol: 'NEAR/USD',
  logo: 'https://cryptologos.cc/logos/near-protocol-near-logo.svg',
  leverage: '5x',
  price: 5.423,
  change24h: 0.78,
  low24h: 5.312,
  high24h: 5.567,
  volume24h: '5.4M',
  marketCap: '$5.9B',
  isFavorite: false,
  priceHistory: [5.35, 5.36, 5.37, 5.38, 5.39, 5.4, 5.41, 5.42, 5.43, 5.44, 5.45, 5.46, 5.47, 5.46, 5.45, 5.44, 5.43, 5.42, 5.43, 5.43, 5.43, 5.423, 5.423, 5.423]
}];
// Map existing marketData to include marketCap
const existingMarketCaps: Record<string, string> = {
  'BTC/USD': '$1.87T',
  'ETH/USD': '$397B',
  'BTC Perp': '$1.87T',
  'SOL/USD': '$62.3B',
  'ADA/USD': '$15.9B',
  'XRP/USD': '$31.2B',
  'DOT/USD': '$8.7B',
  'AVAX/USD': '$13.1B',
  'LINK/USD': '$8.9B',
  'MATIC/USD': '$7.6B'
};
type SortKey = 'price' | 'change24h' | 'volume' | 'marketCap' | null;
type SortDir = 'asc' | 'desc';
interface MarketTableProps {
  filterTab: string;
  searchQuery: string;
}
export function MarketTable({
  filterTab,
  searchQuery
}: MarketTableProps) {
  const [favorites, setFavorites] = useState<Set<string>>(new Set(marketData.filter(m => m.isFavorite).map(m => m.symbol)));
  const [sortKey, setSortKey] = useState<SortKey>(null);
  const [sortDir, setSortDir] = useState<SortDir>('desc');
  const toggleFavorite = (symbol: string) => {
    setFavorites(prev => {
      const next = new Set(prev);
      if (next.has(symbol)) next.delete(symbol);else next.add(symbol);
      return next;
    });
  };
  const handleSort = (key: SortKey) => {
    if (sortKey === key) {
      setSortDir(d => d === 'desc' ? 'asc' : 'desc');
    } else {
      setSortKey(key);
      setSortDir('desc');
    }
  };
  const SortIcon = ({
    column
  }: {
    column: SortKey;
  }) => {
    if (sortKey !== column) return <ChevronDown size={12} className="text-text-muted opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1297" />;
    return sortDir === 'desc' ? <ChevronDown size={12} className="text-brand-purple-light" data-id="element-1298" /> : <ChevronUp size={12} className="text-brand-purple-light" data-id="element-1299" />;
  };
  const allMarkets: MarketRow[] = useMemo(() => {
    const fromExisting: MarketRow[] = marketData.map(m => ({
      ...m,
      marketCap: existingMarketCaps[m.symbol] || '$0'
    }));
    return [...fromExisting, ...additionalMarkets];
  }, []);
  const filteredMarkets = useMemo(() => {
    let list = [...allMarkets];
    // Filter by tab
    if (filterTab === 'Spot') {
      list = list.filter(m => !m.symbol.includes('Perp'));
    } else if (filterTab === 'Futures') {
      list = list.filter(m => m.symbol.includes('Perp') || parseInt(m.leverage) >= 10);
    } else if (filterTab === 'New Listings') {
      const newSymbols = ['SUI/USD', 'APT/USD', 'ARB/USD', 'OP/USD', 'PEPE/USD'];
      list = list.filter(m => newSymbols.includes(m.symbol));
    }
    // Search
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      list = list.filter(m => m.name.toLowerCase().includes(q) || m.symbol.toLowerCase().includes(q));
    }
    // Sort
    if (sortKey) {
      list.sort((a, b) => {
        let valA = 0;
        let valB = 0;
        if (sortKey === 'price') {
          valA = a.price;
          valB = b.price;
        } else if (sortKey === 'change24h') {
          valA = a.change24h;
          valB = b.change24h;
        } else if (sortKey === 'volume') {
          valA = parseFloat(a.volume24h.replace('M', ''));
          valB = parseFloat(b.volume24h.replace('M', ''));
        }
        return sortDir === 'desc' ? valB - valA : valA - valB;
      });
    }
    return list;
  }, [allMarkets, filterTab, searchQuery, sortKey, sortDir]);
  const formatPrice = (price: number) => {
    if (price < 0.001) return price.toFixed(8);
    if (price < 1) return price.toFixed(4);
    if (price < 100) return price.toFixed(3);
    return price.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  return <div className="glass-border rounded-[20px] overflow-hidden" data-id="element-1300">
      <div className="overflow-x-auto" data-id="element-1301">
        <table className="w-full min-w-[900px]" data-id="element-1302">
          <thead className="bg-background-elevated/50 sticky top-0 z-10" data-id="element-1303">
            <tr className="border-b border-border-subtle" data-id="element-1304">
              <th className="px-4 py-3 text-left w-10" data-id="element-1305" />
              <th className="px-2 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-left w-10" data-id="element-1306">
                #
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-left" data-id="element-1307">
                Market
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right cursor-pointer group" onClick={() => handleSort('price')} data-id="element-1308">
                <span className="inline-flex items-center gap-1" data-id="element-1309">
                  Price <SortIcon column="price" data-id="element-1310" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right cursor-pointer group" onClick={() => handleSort('change24h')} data-id="element-1311">
                <span className="inline-flex items-center gap-1" data-id="element-1312">
                  24h Change <SortIcon column="change24h" data-id="element-1313" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-1314">
                24h High
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-1315">
                24h Low
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right cursor-pointer group" onClick={() => handleSort('volume')} data-id="element-1316">
                <span className="inline-flex items-center gap-1" data-id="element-1317">
                  24h Volume <SortIcon column="volume" data-id="element-1318" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-1319">
                Market Cap
              </th>
              <th className="px-4 py-3 text-xs font-label text-text-tertiary uppercase tracking-wider text-right" data-id="element-1320">
                7d Trend
              </th>
            </tr>
          </thead>
          <tbody data-id="element-1321">
            {filteredMarkets.map((market, idx) => <tr key={market.symbol + market.name} className="border-b border-border-subtle hover:bg-background-elevated/30 transition-colors" data-id="element-1322">
                {/* Favorite */}
                <td className="px-4 py-3" data-id="element-1323">
                  <button onClick={() => toggleFavorite(market.symbol)} className="p-1 rounded-full hover:bg-background-elevated transition-colors" data-id="element-1324">
                    <Star size={14} className={favorites.has(market.symbol) ? 'fill-warning text-warning' : 'text-text-muted hover:text-text-secondary'} data-id="element-1325" />
                  </button>
                </td>

                {/* Rank */}
                <td className="px-2 py-3 text-xs font-numbers text-text-tertiary" data-id="element-1326">
                  {idx + 1}
                </td>

                {/* Market */}
                <td className="px-4 py-3" data-id="element-1327">
                  <div className="flex items-center gap-3" data-id="element-1328">
                    <img src={market.logo} alt={market.name} className="w-7 h-7 object-contain" data-id="element-1329" />
                    <div data-id="element-1330">
                      <div className="text-sm font-medium text-text-primary" data-id="element-1331">
                        {market.symbol}
                      </div>
                      <div className="flex items-center gap-1.5 mt-0.5" data-id="element-1332">
                        <span className="text-[10px] text-text-tertiary" data-id="element-1333">
                          {market.name}
                        </span>
                        <span className="text-[10px] font-medium text-text-tertiary bg-background-elevated px-1.5 py-0.5 rounded border border-border-subtle" data-id="element-1334">
                          {market.leverage}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>

                {/* Price */}
                <td className="px-4 py-3 text-right" data-id="element-1335">
                  <span className="font-numbers text-sm text-text-primary" data-id="element-1336">
                    ${formatPrice(market.price)}
                  </span>
                </td>

                {/* 24h Change */}
                <td className="px-4 py-3 text-right" data-id="element-1337">
                  <span className={`font-numbers text-sm font-medium ${market.change24h >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-1338">
                    {market.change24h >= 0 ? '+' : ''}
                    {market.change24h.toFixed(2)}%
                  </span>
                </td>

                {/* 24h High */}
                <td className="px-4 py-3 text-right" data-id="element-1339">
                  <span className="font-numbers text-sm text-text-secondary" data-id="element-1340">
                    ${formatPrice(market.high24h)}
                  </span>
                </td>

                {/* 24h Low */}
                <td className="px-4 py-3 text-right" data-id="element-1341">
                  <span className="font-numbers text-sm text-text-secondary" data-id="element-1342">
                    ${formatPrice(market.low24h)}
                  </span>
                </td>

                {/* Volume */}
                <td className="px-4 py-3 text-right" data-id="element-1343">
                  <span className="font-numbers text-sm text-text-secondary" data-id="element-1344">
                    ${market.volume24h}
                  </span>
                </td>

                {/* Market Cap */}
                <td className="px-4 py-3 text-right" data-id="element-1345">
                  <span className="font-numbers text-sm text-text-secondary" data-id="element-1346">
                    {market.marketCap}
                  </span>
                </td>

                {/* Sparkline */}
                <td className="px-4 py-3" data-id="element-1347">
                  <div className="flex justify-end" data-id="element-1348">
                    <MiniSparkline data={market.priceHistory} isPositive={market.change24h >= 0} width={80} height={28} data-id="element-1349" />
                  </div>
                </td>
              </tr>)}
            {filteredMarkets.length === 0 && <tr data-id="element-1350">
                <td colSpan={10} className="px-6 py-12 text-center" data-id="element-1351">
                  <div className="text-text-secondary text-sm" data-id="element-1352">
                    No markets found
                  </div>
                </td>
              </tr>}
          </tbody>
        </table>
      </div>
    </div>;
}